import React from "react";
import '../../App.css'
import LibraryCard from "../LibraryCard";
import Roots from "../Roots";
export default function Library(){
    return (
        <>
            <LibraryCard />
            <Roots />
        </>

    )
}